import React from 'react';

import { get } from 'lodash';
import {
  BulkActionsToolbar,
  ListBase,
  ListToolbar,
  useGetOne,
  useListContext,
  useTranslate,
} from 'react-admin';

import { Card } from '@material-ui/core';

import Pagination from '../components/lists/Pagination';
import ResponsiveList from '../components/lists/ResponsiveList';
import { useListStyles } from '../components/lists/useStyles';
import perPage from '../utils/per-page';
import Actions from './Actions';
import BulkActions from './BulkActions';
import EditButton from './buttons/EditButton';
import exporter from './exporter';
import AmountField from './fields/AmountField';
import InvoiceField from './fields/InvoiceField';
import PaymentInfoField from './fields/PaymentInfoField';
import RangeField from './fields/RangeField';
import StatusField from './fields/StatusField';
import TitleField from './fields/TitleField';
import UserField from './fields/UserField';
import Filters from './Filters';

const Grid = ({ permissions, range, ...props }) => {
	const listContext = useListContext();
	return (
		<ResponsiveList
			{...listContext}
			{...props}
			isRowSelectable={(record) => record.is_total !== true}
			mobileHeader={
				<React.Fragment>
					<TitleField
						isAdmin={permissions && permissions("admin")}
						variant="subtitle2"
						style={{ fontWeight: "bold" }}
					/>
					<EditButton isAdmin={permissions && permissions("admin")} />
				</React.Fragment>
			}
			mobileActions={
				<React.Fragment>
					<InvoiceField source="invoice" sortable={false} range={range} />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					<StatusField source="status.name" />
					<AmountField source="amount" />
					<PaymentInfoField source="payment_method_data" sortable={false} />
				</React.Fragment>
			}
		>
			{permissions && permissions("admin") && (
				<UserField
					source="user.name"
					sortable={true}
					sortBy="UserProfiles.name"
					style={{ fontWeight: "bold" }}
				/>
			)}
			<RangeField
				source="range"
				sortBy="month"
				style={{ fontWeight: "bold" }}
			/>
			<AmountField source="amount" />
			<StatusField source="status.name" sortBy="UserPaymentStatuses.id" />
			<InvoiceField source="invoice" sortable={false} range={range} />
			<PaymentInfoField source="payment_method_data" sortable={false} />
		</ResponsiveList>
	);
};

const CustomList = ({ range, ...props }) => {
	return (
		<ListBase {...props}>
			<ListToolbar
				filters={
					<Filters resource="user-payments" permissions={props.permissions} />
				}
				actions={props.actions}
			/>
			<Card className={props.classes.main}>
				<div className={props.classes.content}>
					<BulkActionsToolbar>{props.bulkActionButtons}</BulkActionsToolbar>
					<Grid
						permissions={props.permissions}
						hasBulkActions={props.bulkActionButtons !== false}
						range={range}
					/>
					<Pagination />
					<BulkActionsToolbar>{props.bulkActionButtons}</BulkActionsToolbar>
				</div>
			</Card>
		</ListBase>
	);
};

const List = (props) => {
	const translate = useTranslate();
	const classes = useListStyles();
	const { data } = useGetOne("user-payments", "last-range");
	const range = get(data, "range");
	return (
		<CustomList
			{...props}
			classes={classes}
			perPage={perPage(100, 25)}
			filters={<Filters permissions={props.permissions} />}
			actions={<Actions permissions={props.permissions} />}
			bulkActionButtons={
				props.permissions && props.permissions("admin") ? (
					<BulkActions />
				) : (
					false
				)
			}
			permissions={props.permissions}
			pagination={<Pagination />}
			exporter={(records) => exporter(records, translate)}
			title="menu.items.user-payments"
			filterDefaultValues={{
				user_payment_status_id:
					props.permissions && props.permissions("admin") ? 1 : null,
				range,
			}}
			range={range}
		/>
	);
};
export default List;
